import { resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, createElementVNode as _createElementVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "section_sidebarFixedLeft" }
const _hoisted_2 = /*#__PURE__*/_createElementVNode("span", null, "系統設定", -1)
const _hoisted_3 = /*#__PURE__*/_createElementVNode("span", null, "基本設定", -1)
const _hoisted_4 = /*#__PURE__*/_createElementVNode("span", null, "運費設定", -1)
const _hoisted_5 = /*#__PURE__*/_createElementVNode("span", null, "休假設定", -1)
const _hoisted_6 = /*#__PURE__*/_createElementVNode("span", null, "商品管理", -1)
const _hoisted_7 = /*#__PURE__*/_createElementVNode("span", null, "商品列表", -1)
const _hoisted_8 = /*#__PURE__*/_createElementVNode("span", null, "商品分類", -1)
const _hoisted_9 = /*#__PURE__*/_createElementVNode("span", null, "單日商品特賣", -1)
const _hoisted_10 = /*#__PURE__*/_createElementVNode("span", null, "商品未來價格", -1)
const _hoisted_11 = /*#__PURE__*/_createElementVNode("span", null, "懶人包", -1)
const _hoisted_12 = /*#__PURE__*/_createElementVNode("span", { class: "section_horizon_box" }, "取貨點管理", -1)
const _hoisted_13 = /*#__PURE__*/_createElementVNode("span", { class: "section_horizon_box" }, "訂單管理", -1)
const _hoisted_14 = /*#__PURE__*/_createElementVNode("span", { class: "section_horizon_box" }, "折扣管理", -1)
const _hoisted_15 = /*#__PURE__*/_createElementVNode("span", { class: "section_horizon_box" }, "待出貨商品", -1)
const _hoisted_16 = /*#__PURE__*/_createElementVNode("span", { class: "section_horizon_box" }, "送貨管理", -1)
const _hoisted_17 = /*#__PURE__*/_createElementVNode("span", { class: "section_horizon_box" }, "送貨管理-新", -1)
const _hoisted_18 = /*#__PURE__*/_createElementVNode("span", { class: "section_horizon_box" }, "地址管理", -1)
const _hoisted_19 = /*#__PURE__*/_createElementVNode("span", { class: "section_horizon_box" }, "進貨管理", -1)
const _hoisted_20 = /*#__PURE__*/_createElementVNode("span", { class: "section_horizon_box" }, "使用者管理", -1)
const _hoisted_21 = /*#__PURE__*/_createElementVNode("span", { class: "section_horizon_box" }, "列印管理", -1)
const _hoisted_22 = {
  href: "https://ai-analyze.web.app/",
  target: "_blank",
  style: {"text-decoration":"none","font-weight":"normal"}
}
const _hoisted_23 = /*#__PURE__*/_createElementVNode("span", { class: "section_horizon_box" }, "AI預測", -1)
const _hoisted_24 = /*#__PURE__*/_createElementVNode("a", {
  href: "https://bots.tw",
  target: "_blank"
}, null, -1)

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_info_filled = _resolveComponent("info-filled")!
  const _component_el_icon = _resolveComponent("el-icon")!
  const _component_house = _resolveComponent("house")!
  const _component_el_menu_item = _resolveComponent("el-menu-item")!
  const _component_finished = _resolveComponent("finished")!
  const _component_files = _resolveComponent("files")!
  const _component_el_menu_item_group = _resolveComponent("el-menu-item-group")!
  const _component_el_sub_menu = _resolveComponent("el-sub-menu")!
  const _component_list = _resolveComponent("list")!
  const _component_goods = _resolveComponent("goods")!
  const _component_fold = _resolveComponent("fold")!
  const _component_Connection = _resolveComponent("Connection")!
  const _component_notebook = _resolveComponent("notebook")!
  const _component_van = _resolveComponent("van")!
  const _component_map_location = _resolveComponent("map-location")!
  const _component_avatar = _resolveComponent("avatar")!
  const _component_printer = _resolveComponent("printer")!
  const _component_magic_stick = _resolveComponent("magic-stick")!
  const _component_el_menu = _resolveComponent("el-menu")!
  const _component_el_scrollbar = _resolveComponent("el-scrollbar")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(_component_el_scrollbar, { style: {"height":"70%"} }, {
      default: _withCtx(() => [
        _createVNode(_component_el_menu, {
          "default-active": "1",
          router: true,
          "default-openeds": ['1', '2']
        }, {
          default: _withCtx(() => [
            _createVNode(_component_el_sub_menu, { index: "1" }, {
              title: _withCtx(() => [
                _createVNode(_component_el_icon, null, {
                  default: _withCtx(() => [
                    _createVNode(_component_info_filled)
                  ]),
                  _: 1
                }),
                _hoisted_2
              ]),
              default: _withCtx(() => [
                _createVNode(_component_el_menu_item_group, null, {
                  default: _withCtx(() => [
                    _createVNode(_component_el_menu_item, { index: "/system/info" }, {
                      title: _withCtx(() => [
                        _createVNode(_component_el_icon, null, {
                          default: _withCtx(() => [
                            _createVNode(_component_house)
                          ]),
                          _: 1
                        }),
                        _hoisted_3
                      ]),
                      _: 1
                    }),
                    _createVNode(_component_el_menu_item, { index: "/system/shippingRule" }, {
                      title: _withCtx(() => [
                        _createVNode(_component_el_icon, null, {
                          default: _withCtx(() => [
                            _createVNode(_component_finished)
                          ]),
                          _: 1
                        }),
                        _hoisted_4
                      ]),
                      _: 1
                    }),
                    _createVNode(_component_el_menu_item, { index: "/system/closeDate" }, {
                      title: _withCtx(() => [
                        _createVNode(_component_el_icon, null, {
                          default: _withCtx(() => [
                            _createVNode(_component_files)
                          ]),
                          _: 1
                        }),
                        _hoisted_5
                      ]),
                      _: 1
                    })
                  ]),
                  _: 1
                })
              ]),
              _: 1
            }),
            _createVNode(_component_el_sub_menu, { index: "2" }, {
              title: _withCtx(() => [
                _createVNode(_component_el_icon, null, {
                  default: _withCtx(() => [
                    _createVNode(_component_list)
                  ]),
                  _: 1
                }),
                _hoisted_6
              ]),
              default: _withCtx(() => [
                _createVNode(_component_el_menu_item_group, null, {
                  default: _withCtx(() => [
                    _createVNode(_component_el_menu_item, { index: "/goodsList" }, {
                      title: _withCtx(() => [
                        _createVNode(_component_el_icon, null, {
                          default: _withCtx(() => [
                            _createVNode(_component_goods)
                          ]),
                          _: 1
                        }),
                        _hoisted_7
                      ]),
                      _: 1
                    }),
                    _createVNode(_component_el_menu_item, { index: "/goodsCategory" }, {
                      title: _withCtx(() => [
                        _createVNode(_component_el_icon, null, {
                          default: _withCtx(() => [
                            _createVNode(_component_fold)
                          ]),
                          _: 1
                        }),
                        _hoisted_8
                      ]),
                      _: 1
                    }),
                    _createVNode(_component_el_menu_item, { index: "/goodsTodayLimit" }, {
                      title: _withCtx(() => [
                        _createVNode(_component_el_icon, null, {
                          default: _withCtx(() => [
                            _createVNode(_component_fold)
                          ]),
                          _: 1
                        }),
                        _hoisted_9
                      ]),
                      _: 1
                    }),
                    (_ctx.title === '胖蔬生鮮')
                      ? (_openBlock(), _createBlock(_component_el_menu_item, {
                          key: 0,
                          index: "/goodsFuturePrice"
                        }, {
                          title: _withCtx(() => [
                            _createVNode(_component_el_icon, null, {
                              default: _withCtx(() => [
                                _createVNode(_component_fold)
                              ]),
                              _: 1
                            }),
                            _hoisted_10
                          ]),
                          _: 1
                        }))
                      : _createCommentVNode("", true),
                    (_ctx.title === '新鮮菓樂園/新竹鮮果樂園')
                      ? (_openBlock(), _createBlock(_component_el_menu_item, {
                          key: 1,
                          index: "/goodsSummary"
                        }, {
                          title: _withCtx(() => [
                            _createVNode(_component_el_icon, null, {
                              default: _withCtx(() => [
                                _createVNode(_component_fold)
                              ]),
                              _: 1
                            }),
                            _hoisted_11
                          ]),
                          _: 1
                        }))
                      : _createCommentVNode("", true)
                  ]),
                  _: 1
                })
              ]),
              _: 1
            }),
            _createVNode(_component_el_menu_item, { index: "/community" }, {
              title: _withCtx(() => [
                _hoisted_12
              ]),
              default: _withCtx(() => [
                _createVNode(_component_el_icon, null, {
                  default: _withCtx(() => [
                    _createVNode(_component_Connection)
                  ]),
                  _: 1
                })
              ]),
              _: 1
            }),
            _createVNode(_component_el_menu_item, { index: "/orderList" }, {
              title: _withCtx(() => [
                _hoisted_13
              ]),
              default: _withCtx(() => [
                _createVNode(_component_el_icon, null, {
                  default: _withCtx(() => [
                    _createVNode(_component_notebook)
                  ]),
                  _: 1
                })
              ]),
              _: 1
            }),
            _createVNode(_component_el_menu_item, { index: "/discount" }, {
              title: _withCtx(() => [
                _hoisted_14
              ]),
              default: _withCtx(() => [
                _createVNode(_component_el_icon, null, {
                  default: _withCtx(() => [
                    _createVNode(_component_notebook)
                  ]),
                  _: 1
                })
              ]),
              _: 1
            }),
            _createVNode(_component_el_menu_item, { index: "/orderGoodsList" }, {
              title: _withCtx(() => [
                _hoisted_15
              ]),
              default: _withCtx(() => [
                _createVNode(_component_el_icon, null, {
                  default: _withCtx(() => [
                    _createVNode(_component_notebook)
                  ]),
                  _: 1
                })
              ]),
              _: 1
            }),
            _createVNode(_component_el_menu_item, { index: "/deliveryList" }, {
              title: _withCtx(() => [
                _hoisted_16
              ]),
              default: _withCtx(() => [
                _createVNode(_component_el_icon, null, {
                  default: _withCtx(() => [
                    _createVNode(_component_van)
                  ]),
                  _: 1
                })
              ]),
              _: 1
            }),
            (_ctx.title==='鮮食宅' || _ctx.title==='新鮮菓樂園/新竹鮮果樂園')
              ? (_openBlock(), _createBlock(_component_el_menu_item, {
                  key: 0,
                  index: "/deliveryList-new"
                }, {
                  title: _withCtx(() => [
                    _hoisted_17
                  ]),
                  default: _withCtx(() => [
                    _createVNode(_component_el_icon, null, {
                      default: _withCtx(() => [
                        _createVNode(_component_van)
                      ]),
                      _: 1
                    })
                  ]),
                  _: 1
                }))
              : _createCommentVNode("", true),
            (_ctx.title === '鮮食宅' || _ctx.title === '新鮮菓樂園/新竹鮮果樂園')
              ? (_openBlock(), _createBlock(_component_el_menu_item, {
                  key: 1,
                  index: "/addressManage"
                }, {
                  title: _withCtx(() => [
                    _hoisted_18
                  ]),
                  default: _withCtx(() => [
                    _createVNode(_component_el_icon, null, {
                      default: _withCtx(() => [
                        _createVNode(_component_map_location)
                      ]),
                      _: 1
                    })
                  ]),
                  _: 1
                }))
              : _createCommentVNode("", true),
            (_ctx.title === '測試')
              ? (_openBlock(), _createBlock(_component_el_menu_item, {
                  key: 2,
                  index: "/restock"
                }, {
                  title: _withCtx(() => [
                    _hoisted_19
                  ]),
                  default: _withCtx(() => [
                    _createVNode(_component_el_icon, null, {
                      default: _withCtx(() => [
                        _createVNode(_component_van)
                      ]),
                      _: 1
                    })
                  ]),
                  _: 1
                }))
              : _createCommentVNode("", true),
            _createVNode(_component_el_menu_item, { index: "/userList" }, {
              title: _withCtx(() => [
                _hoisted_20
              ]),
              default: _withCtx(() => [
                _createVNode(_component_el_icon, null, {
                  default: _withCtx(() => [
                    _createVNode(_component_avatar)
                  ]),
                  _: 1
                })
              ]),
              _: 1
            }),
            _createVNode(_component_el_menu_item, { index: "/print" }, {
              title: _withCtx(() => [
                _hoisted_21
              ]),
              default: _withCtx(() => [
                _createVNode(_component_el_icon, null, {
                  default: _withCtx(() => [
                    _createVNode(_component_printer)
                  ]),
                  _: 1
                })
              ]),
              _: 1
            }),
            _createElementVNode("a", _hoisted_22, [
              (_ctx.title === '鮮食宅')
                ? (_openBlock(), _createBlock(_component_el_menu_item, { key: 0 }, {
                    title: _withCtx(() => [
                      _hoisted_23
                    ]),
                    default: _withCtx(() => [
                      _createVNode(_component_el_icon, null, {
                        default: _withCtx(() => [
                          _createVNode(_component_magic_stick)
                        ]),
                        _: 1
                      })
                    ]),
                    _: 1
                  }))
                : _createCommentVNode("", true)
            ])
          ]),
          _: 1
        })
      ]),
      _: 1
    }),
    _hoisted_24
  ]))
}